export const ENV_BACKEND_URL = {
  dev: 'https://master-backend-agreements.dev.agreements.aservices.tech',
  rc: 'https://release-backend-agreements.rc.agreements.aservices.tech',
  stable: 'https://stable-backend-agreements.rc.agreements.aservices.tech',
  prod: 'https://agreements.action-media.ru',
}

export type TEnv = 'dev' | 'rc' | 'stable' | 'prod'
